<template>
  <modal name="nav-links-modal" adaptive :pivotY="0.1" :width="620" height="auto" classes="wf-shadow-xl wf-rounded-lg wf-bg-white wf-px-4 wf-py-4" @before-open="beforeOpen" @closed="closed">
    <div>
      <draggable group="navLinks" :list="navLinks" handle=".nav-link-handle" class="wf-flex wf-flex-wrap wf-flex-col">
        <div v-for="(navLink, index) in navLinks" :key="navLink.text" class="wf-mb-2">
          <div class="wf-flex wf-flex-wrap wf-group wf-bg-gray-200 wf-pr-2 wf-border wf-rounded-sm wf-shadow-sm wf-w-full">
            <div class="wf-self-stretch">
              <button
                class="wf-h-full wf-w-8 focus:wf-outline-none wf-bg-gray-300"
                :class="editingIndex === null && (editingChild.index === null || editingChild.childIndex === null)  && (editingGrandchild.grandchildIndex === null) ? ['nav-link-handle', 'wf-cursor-move'] : ['wf-cursor-default']"
              ><i class="wf-text-gray-500 wf-text-xl fas fa-grip-lines-vertical"></i></button>
            </div>
            <div class="wf-flex-1">
              <div class="wf-flex wf-items-center wf-w-full">
                <div class="wf-ml-2 wf-p-2" v-show="editingIndex != index">
                  <div class="wf-text-gray-800 wf-font-semibold wf-text-sm" v-text="navLink.text"></div>
                  <div v-show="! navLink.children.length" class="wf-text-xs wf-text-gray-600" v-text="navLink.link"></div>
                </div>
                <div class="wf-ml-2 wf-flex wf-py-1 wf-items-center wf-w-full" v-show="editingIndex == index">
                  <div>
                    <label for="" class="wf-text-xxs wf-leading-none wf-block wf-m-0">Text</label>
                    <input @input="updateNavLink($event.target.value, 'text', index)" :value="navLink.text" type="text" class="wf-w-40 wf-h-5 wf-rounded-sm wf-mr-2 wf-text-xs focus:wf-outline-none wf-px-2">
                  </div>
                  <div>
                    <label for="" class="wf-text-xxs wf-leading-none wf-block wf-m-0">Link</label>
                    <input @input="updateNavLink($event.target.value, 'link', index)" :value="navLink.link" type="text" class="wf-w-40 wf-h-5 wf-rounded-sm wf-mr-2 wf-text-xs focus:wf-outline-none wf-px-2">
                  </div>
                  <div>
                    <label for="" class="wf-text-xxs wf-leading-none wf-block wf-m-0">Target</label>
                    <select @change="updateNavLink($event.target.value, 'target', index)" :value="navLink.target" class="wf-w-40 wf-h-5 wf-rounded-sm wf-text-xs focus:wf-outline-none wf-px-2">
                      <option value="_self">Same window</option>
                      <option value="_blank">New window</option>
                    </select>
                  </div>
                  <div class="wf-w-8 wf-pt-1 wf-flex wf-flex-col wf-justify-center wf-ml-auto wf-items-end">
                    <button @click.prevent="editingIndex = null" class="focus:wf-outline-none"><i class="fas fa-check wf-text-gray-500 wf-text-sm"></i></button>
                  </div>
                </div>
                <button
                  v-show="editingIndex === null && (editingChild.index === null || editingChild.childIndex === null) && (editingGrandchild.grandchildIndex === null)"
                  @click.prevent="removeNavLink(index)"
                  class="group-hover:wf-inline-block wf-hidden wf-ml-auto focus:wf-outline-none"
                ><i class="fas fa-times wf-text-gray-500 wf-text-xs"></i></button>
                <button
                  v-show="editingIndex === null && (editingChild.index === null || editingChild.childIndex === null) && (editingGrandchild.grandchildIndex === null)"
                  @click.prevent="editingIndex = index"
                  class="group-hover:wf-inline-block wf-hidden wf-ml-2 focus:wf-outline-none"
                ><i class="fas fa-pen wf-text-gray-500 wf-text-xs"></i></button>
              </div>
            </div>
          </div>
          <draggable group="navLinks" class="wf-pl-8 wf-pt-1" :list="navLink.children" handle=".nav-link-handle">
            <div v-for="(child, childIndex) in navLink.children" :key="child.text" class="wf-mb-1">
              <div class="wf-flex wf-bg-gray-200 wf-border wf-shadow-sm">
                <div class="wf-self-stretch">
                  <button
                    class="wf-h-full wf-w-8 focus:wf-outline-none wf-bg-gray-300"
                    :class="editingIndex === null && (editingChild.index === null || editingChild.childIndex === null)  && (editingGrandchild.grandchildIndex === null) ? ['nav-link-handle', 'wf-cursor-move'] : ['wf-cursor-default']"
                  ><i class="wf-text-gray-500 wf-text-xl fas fa-grip-lines-vertical"></i></button>
                </div>
                <div class="wf-p-2 wf-group wf-flex wf-w-full wf-items-center" v-show="editingChild.childIndex != childIndex">
                  <div>
                    <div class="wf-text-gray-800 wf-font-semibold wf-text-sm" v-text="child.text"></div>
                    <div v-show="! child.children.length" class="wf-text-xs wf-text-gray-600" v-text="child.link"></div>  
                  </div>                
                  <div class="wf-ml-auto">
                    <button
                      v-show="editingIndex === null  && editingGrandchild.grandchildIndex === null"
                      @click.prevent="removeChild(index, childIndex)"
                      class="group-hover:wf-inline-block wf-hidden focus:wf-outline-none"
                    ><i class="fas fa-times wf-text-gray-500 wf-text-xs"></i></button>
                    <button
                      v-show="editingIndex === null  && editingGrandchild.grandchildIndex === null"
                      @click.prevent="editChild(index, childIndex)"
                      class="group-hover:wf-inline-block wf-hidden wf-ml-2 focus:wf-outline-none"
                    ><i class="fas fa-pen wf-text-gray-500 wf-text-xs"></i></button>
                  </div>
                </div>
                <div class="wf-p-2 wf-group wf-flex wf-w-full wf-items-center" v-show="editingChild.index === index && editingChild.childIndex === childIndex">
                  <div class="wf-flex">
                    <div>
                      <label for="" class="wf-text-xxs wf-leading-none wf-block wf-m-0">Text</label>
                      <input @input="updateChild($event.target.value, 'text', index, childIndex)" :value="child.text" type="text" class="wf-w-40 wf-h-5 wf-rounded-sm wf-mr-2 wf-text-xs focus:wf-outline-none wf-px-2">
                    </div>
                    <div>
                      <label for="" class="wf-text-xxs wf-leading-none wf-block wf-m-0">Link</label>
                      <input @input="updateChild($event.target.value, 'link', index, childIndex)" :value="child.link" type="text" class="wf-w-40 wf-h-5 wf-rounded-sm wf-mr-2 wf-text-xs focus:wf-outline-none wf-px-2">
                    </div>
                    <div>
                      <label for="" class="wf-text-xxs wf-leading-none wf-block wf-m-0">Target</label>
                      <select @change="updateChild($event.target.value, 'target', index, childIndex)" :value="child.target" class="wf-w-32 wf-h-5 wf-rounded-sm wf-text-xs focus:wf-outline-none wf-px-2">
                        <option value="_self">Same window</option>
                        <option value="_blank">New window</option>
                      </select>
                    </div>
                  </div>                
                  <div class="wf-ml-auto">
                    <button
                      @click.prevent="editingChild = {index: null, childIndex: null}"
                      class="group-hover:wf-inline-block wf-hidden focus:wf-outline-none"
                    ><i class="fas fa-check wf-text-gray-500 wf-text-xs"></i></button>
                  </div>
                </div>
              </div>
              <draggable group="navLinks" class="wf-pl-8 wf-pt-1" :list="child.children" handle=".nav-link-handle">
                <div v-for="(grandchild, grandchildIndex) in child.children" :key="grandchild.text" class="wf-mb-1">
                  <div class="wf-flex wf-bg-gray-200 wf-border wf-shadow-sm">
                    <div class="wf-self-stretch">
                      <button
                        class="wf-h-full wf-w-8 focus:wf-outline-none wf-bg-gray-300"
                        :class="editingIndex === null && (editingChild.index === null && editingChild.childIndex === null) && (editingGrandchild.index === null && editingGrandchild.childIndex === null && editingGrandchild.grandchildIndex === null)  ? ['nav-link-handle', 'wf-cursor-move'] : ['wf-cursor-default']"
                      ><i class="wf-text-gray-500 wf-text-xl fas fa-grip-lines-vertical"></i></button>
                    </div>
                    <div class="wf-p-2 wf-group wf-flex wf-w-full wf-items-center" v-show="editingGrandchild.grandchildIndex != grandchildIndex">
                      <div>
                        <div class="wf-text-gray-800 wf-font-semibold wf-text-sm" v-text="grandchild.text"></div>
                        <div class="wf-text-xs wf-text-gray-600" v-text="grandchild.link"></div>  
                      </div>
                      <div class="wf-ml-auto">
                        <button
                          v-show="editingIndex === null && editingChild.childIndex === null"
                          @click.prevent="removeGrandchild(index, childIndex, grandchildIndex)"
                          class="group-hover:wf-inline-block wf-hidden focus:wf-outline-none"
                        ><i class="fas fa-times wf-text-gray-500 wf-text-xs"></i></button>
                        <button
                          v-show="editingIndex === null && editingChild.childIndex === null"
                          @click.prevent="editGrandchild(index, childIndex, grandchildIndex)"
                          class="group-hover:wf-inline-block wf-hidden wf-ml-2 focus:wf-outline-none"
                        ><i class="fas fa-pen wf-text-gray-500 wf-text-xs"></i></button>
                      </div>
                    </div>
                    <div class="wf-p-2 wf-group wf-flex wf-w-full wf-items-center" v-show="editingGrandchild.index === index && editingGrandchild.childIndex === childIndex && editingGrandchild.grandchildIndex === grandchildIndex">
                      <div class="wf-flex">
                        <div>
                          <label for="" class="wf-text-xxs wf-leading-none wf-block wf-m-0">Text</label>
                          <input @input="updateGrandchild($event.target.value, 'text', index, childIndex, grandchildIndex)" :value="grandchild.text" type="text" class="wf-w-32 wf-h-5 wf-rounded-sm wf-mr-2 wf-text-xs focus:wf-outline-none wf-px-2">
                        </div>
                        <div>
                          <label for="" class="wf-text-xxs wf-leading-none wf-block wf-m-0">Link</label>
                          <input @input="updateGrandchild($event.target.value, 'link', index, childIndex, grandchildIndex)" :value="grandchild.link" type="text" class="wf-w-40 wf-h-5 wf-rounded-sm wf-mr-2 wf-text-xs focus:wf-outline-none wf-px-2">
                        </div>
                        <div>
                          <label for="" class="wf-text-xxs wf-leading-none wf-block wf-m-0">Target</label>
                          <select @change="updateGrandchild($event.target.value, 'target', index, childIndex, grandchildIndex)" :value="grandchild.target" class="wf-w-32 wf-h-5 wf-rounded-sm wf-text-xs focus:wf-outline-none wf-px-2">
                            <option value="_self">Same window</option>
                            <option value="_blank">New window</option>
                          </select>
                        </div>
                      </div>                
                      <div class="wf-ml-auto">
                        <button
                          @click.prevent="editingGrandchild = {index: null, childIndex: null, grandchildIndex: null}"
                          class="group-hover:wf-inline-block wf-hidden focus:wf-outline-none"
                        ><i class="fas fa-check wf-text-gray-500 wf-text-xs"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </draggable>
        </div>
      </draggable>
      <div class="wf-w-full">
        <button @click.prevent="addNavLink" class="focus:wf-outline-none wf-uppercase wf-text-xs wf-font-bold wf-tracking-wide wf-self-end wf-text-gray-500 wf-text-center wf-border wf-border-dashed wf-border-gray-500 wf-px-4 wf-h-10 wf-rounded-sm wf-w-full"><i class="fas fa-plus wf-mr-2"></i>add nav link</button>
      </div>
      <div class="wf-mt-4 wf-flex wf-flex-wrap wf-justify-end">
        <button @click.prevent="$modal.hide('nav-links-modal')" class="wf-h-10 wf-w-32 wf-bg-gray-300 wf-rounded wf-text-xs wf-uppercase wf-font-bold wf-tracking-wide focus:wf-outline-none wf-text-gray-800">Cancel</button>
        <button @click.prevent="submit" class="wf-h-10 wf-w-32 wf-bg-blue-300 wf-rounded wf-text-xs wf-uppercase wf-font-bold wf-tracking-wide focus:wf-outline-none wf-text-blue-800 wf-ml-2">Save</button>
      </div>
    </div>
  </modal>
</template>
<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
export default {
  components: {
    draggable,
  },
  data() {
    return {
      editingIndex: null,
      editingChild: {
        index: null,
        childIndex: null
      },
      editingGrandchild: {
        index: null,
        childIndex: null,
        grandchildIndex: null
      },
      navLinks: []
    }
  },
  methods: {
    updateGrandchild: _.debounce( function(value, key, index, childIndex, grandchildIndex) {
      let navLink = Object.assign({}, {...this.navLinks[index]})
      let childLink = Object.assign({}, {...this.navLinks[index].children[childIndex]})
      let grandchildren = childLink.children.map((grandchild, originalGrandchildIndex) => {
        if (originalGrandchildIndex != grandchildIndex) {
          return grandchild
        }
        this.$set(grandchild, key, value)
        return grandchild
      })
      this.$set(navLink.children[childIndex], 'children', grandchildren)
      this.navLinks = this.navLinks.map((originalNavLink, navLinkIndex) => {
        if (navLinkIndex != index) {
          return originalNavLink
        }
        return navLink
      })
    }, 500),
    updateChild: _.debounce( function(value, key, index, childIndex) {
      let navLink = Object.assign({}, { ...this.navLinks[index] })
      let children = navLink.children.map((child, originalChildIndex) => {
        if (originalChildIndex != childIndex) {
          return child
        }
        this.$set(child, key, value)
        return child
      })
      this.$set(navLink, 'children', children)
      this.navLinks = this.navLinks.map((originalNavLink, navLinkIndex) => {
        if (navLinkIndex != index) {
          return originalNavLink
        }
        return navLink
      })
    }, 500),
    removeGrandchild(index, childIndex, grandchildIndex) {
      console.log(index, childIndex, grandchildIndex)
    },
    editGrandchild(index, childIndex, grandchildIndex) {
      this.editingGrandchild = {
        index: index,
        childIndex: childIndex,
        grandchildIndex: grandchildIndex,
      }
    },
    removeChild(index, childIndex) {
      this.navLinks = Array.from(this.navLinks).map((navLink, originalIndex) => {
        if (originalIndex != index) {
          return navLink
        }
        let children  = Array.from(navLink.children).filter((child, originalChildIndex) => originalChildIndex != childIndex)
        return {...navLink, children: children}
      })
    },
    editChild(index, childIndex) {
      this.editingChild = {
        index: index,
        childIndex: childIndex,
      }
    },
    removeNavLink(index) {
      this.navLinks = Array.from(this.navLinks).filter((navLink, originalIndex) => originalIndex != index)
    },
    addNavLink() {
      this.navLinks = [...this.navLinks, {
        text: 'New Link',
        link: '#',
        target: '_self',
        children: []
      }]
    },
    updateNavLink: _.debounce( function(value, key, index) {
      let navLink = Object.assign({}, { ...this.navLinks[index] })
      this.$set(navLink, key, value)
      this.navLinks = this.navLinks.map((originalNavLink, navLinkIndex) => {
        if (navLinkIndex != index) {
          return originalNavLink
        }
        return navLink
      })
    }, 500),
    beforeOpen(event) {
      this.navLinks = JSON.parse(JSON.stringify(event.params.navLinks))
    },
    submit() {
      this.$emit('submit', this.navLinks)
      this.$modal.hide('nav-links-modal')
    },
    closed() {
      this.navLinks = []
      this.editingIndex = null
      this.editingChild = {
        index: null,
        childIndex: null
      }
      this.editingGrandchild = {
        index: null,
        childIndex: null,
        grandchildIndex: null 
      }
    }
  },
}

</script>
